var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalcardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H19M15 12H19M17 16H19M17 21H7C3 21 2 20 2 16V8C2 4 3 3 7 3H17C21 3 22 4 22 8V16C22 20 21 21 17 21Z",
    stroke: "#092540",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.33C11.9327 15.628 11.6219 14.9718 11.1214 14.475C10.621 13.9782 9.96243 13.6721 9.26 13.61C8.75457 13.56 8.24543 13.56 7.74 13.61C7.03826 13.674 6.38078 13.9806 5.88069 14.4771C5.3806 14.9735 5.06918 15.6287 5 16.33M8.5 11.29C8.98004 11.29 9.44042 11.0993 9.77986 10.7598C10.1193 10.4204 10.31 9.96002 10.31 9.47998C10.31 8.99994 10.1193 8.53956 9.77986 8.20012C9.44042 7.86068 8.98004 7.66998 8.5 7.66998C8.01996 7.66998 7.55958 7.86068 7.22014 8.20012C6.8807 8.53956 6.69 8.99994 6.69 9.47998C6.69 9.96002 6.8807 10.4204 7.22014 10.7598C7.55958 11.0993 8.01996 11.29 8.5 11.29Z",
    stroke: "#092540",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcardIcon);
export default __webpack_public_path__ + "static/media/personalcard-icon.dd0787b3da415d264dd3583865a1734d.svg";
export { ForwardRef as ReactComponent };